import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BoothInfo.css';
import mapimg from './assets/map.png';
import 장소 from './assets/지도_장소.png';


const MIN_SPEED = 1.0;
const MAX_SPEED = 2.0;

function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

class Blob {
  constructor(el) {
    this.el = el;
    const boundingRect = this.el.getBoundingClientRect();
    this.size = boundingRect.width;
    this.initialX = randomNumber(0, window.innerWidth - this.size);
    this.initialY = randomNumber(0, window.innerHeight - this.size);
    this.el.style.top = `${this.initialY}px`;
    this.el.style.left = `${this.initialX}px`;
    this.vx = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.vy = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.x = this.initialX;
    this.y = this.initialY;
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
    if (this.x >= window.innerWidth - this.size) {
      this.x = window.innerWidth - this.size;
      this.vx *= -1;
    }
    if (this.y >= window.innerHeight - this.size) {
      this.y = window.innerHeight - this.size;
      this.vy *= -1;
    }
    if (this.x <= 0) {
      this.x = 0;
      this.vx *= -1;
    }
    if (this.y <= 0) {
      this.y = 0;
      this.vy *= -1;
    }
  }

  move() {
    this.el.style.transform = `translate(${this.x - this.initialX}px, ${this.y - this.initialY}px)`;
  }
}

const BoothInfo = () => {
  useEffect(() => {
    const initBlobs = () => {
      const blobEls = document.querySelectorAll('.bouncing-blob');
      const blobs = Array.from(blobEls).map((blobEl) => new Blob(blobEl));

      function update() {
        requestAnimationFrame(update);
        blobs.forEach((blob) => {
          blob.update();
          blob.move();
        });
      }

      requestAnimationFrame(update);
    };

    initBlobs();
  }, []);

  return (
    <div className="page2">

      <div className="mapbox">
        <p className="text">지도를 터치하면 해당 부스 정보로 이동합니다.</p>
        <img className="map" src={mapimg} alt="map" useMap="#image-map" />
        <img className="map2" src={장소} alt="map2" />

        <map name="image-map">
          <Link to="/jujeom-booth">
            <area alt="" title="" coords="228,48,254,99,341,52,315,5" shape="poly" />
          </Link>
          <Link to="/ste-booth">
            <area alt="" title="" coords="30,24,57,24,57,51,29,51" shape="poly" />
          </Link>
          <Link to="/And-booth">
            <area alt="" title="" coords="72,75,70,92,122,101,124,86" shape="poly" />
          </Link>
          <Link to="/cinderella-booth">
            <area alt="" title="" coords="47,94,62,94,65,110,46,110" shape="poly" />
          </Link>
        </map>
      </div>




      <div className="bouncing-blobs-container">
        <div className="bouncing-blobs-glass"></div>
        <div className="bouncing-blobs">
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--white"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--pink"></div>
        </div>
      </div>
      <div className="hero"></div>
      
      <Link to="/">
      <button
          className="mainBtn2"
          alt="처음으로 버튼"
        >
          BACK
        </button>
        </Link>
    </div>
  );
};

export default BoothInfo;
